import Api from './api';

const NotificationService = {
  index: () => Api.get('/notification/load', { headers: {'Authorization': sessionStorage.getItem('token')} }),

  register: (params) => Api.post('/notification/register', params, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  delete: (notification) => Api.post(`/notification/remove/${notification._id}`, {}, { headers: {'Authorization': sessionStorage.getItem('token')} }),
}

export default NotificationService;
